import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const BankSettings = ({ settings, onReload }) => {
  const [accounts, setAccounts] = useState([]);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setAccounts(["PT", "AO"].map((country) => settings?.bank_accounts?.find((a) => a.country === country) || { country, currency: country === "PT" ? "EUR" : "AOA", holder: "", bank: "", iban: "", enabled: false }));
  }, [settings]);
  const change = (index, field, value) => setAccounts((prev) => prev.map((a, i) => i === index ? { ...a, [field]: value } : a));
  const save = async () => {
    setBusy(true); setMessage("");
    try {
      await api.put("/settings", { bank_accounts: accounts.filter((a) => a.enabled || a.iban || a.bank || a.holder) });
      setMessage("Dados bancários guardados. Apenas as contas ativas são oferecidas no checkout."); await onReload();
    } catch (e) { setMessage(e.response?.data?.detail || "Erro ao guardar dados bancários"); }
    finally { setBusy(false); }
  };
  return (
    <section className="rounded-2xl border border-border bg-card p-6 mb-6" data-testid="bank-settings">
      <h3 className="font-display font-semibold text-lg">Pagamentos por IBAN</h3>
      <p className="text-sm text-muted-foreground mt-2 mb-4">Introduz apenas contas da VOLTIX verificadas. A validação do formato do IBAN não confirma a titularidade.</p>
      <div className="grid md:grid-cols-2 gap-6">
        {accounts.map((a, index) => <div key={a.country} className="space-y-3">
          <h4 className="font-semibold text-sm">{a.country === "PT" ? "Portugal · EUR" : "Angola · AOA"}</h4>
          {[['holder', 'Titular'], ['bank', 'Banco'], ['iban', 'IBAN']].map(([field, label]) => <div key={field}><Label htmlFor={`bank-${field}-${a.country}`}>{label}</Label><Input id={`bank-${field}-${a.country}`} data-testid={`bank-${field}-${a.country}`} value={a[field]} onChange={(e) => change(index, field, e.target.value)} /></div>)}
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" data-testid={`bank-enabled-${a.country}`} checked={a.enabled} onChange={(e) => change(index, "enabled", e.target.checked)} /> Confirmo a conta e ativo transferências</label>
        </div>)}
      </div>
      <Button className="rounded-full mt-5" disabled={busy} data-testid="save-bank-settings" onClick={save}>{busy ? "A guardar…" : "Guardar contas bancárias"}</Button>
      {message && <p className="text-sm mt-3" role="status" data-testid="bank-settings-message">{message}</p>}
      <p className="text-xs text-muted-foreground mt-5" data-testid="payment-integrations-pending">PayPay Angola e Multicaixa Express: ativação comercial pendente. SMS Twilio: credenciais e remetente por configurar.</p>
    </section>
  );
};
